import { TVillageOffersType } from '../constants';
import { IVillageCounterSetSchema } from '../../shared/repositories/countryside-search/entities/counter/VillageCounterSetSchema';

export interface IGetVillageOffersTypeParams {
  builderCounterSet?: IVillageCounterSetSchema | null;
  resaleCounterSet?: IVillageCounterSetSchema | null;
}

export function getVillageOffersType(params: IGetVillageOffersTypeParams): TVillageOffersType | undefined {
  const { builderCounterSet, resaleCounterSet } = params;

  if (!builderCounterSet || !resaleCounterSet) {
    return undefined;
  }

  if (builderCounterSet.total && resaleCounterSet.total) {
    return 'resaleAndBuilder';
  }

  if (builderCounterSet.total) {
    return 'builder';
  }
  if (resaleCounterSet.total) {
    return 'resale';
  }

  return undefined;
}
